__turbopack_context__.v({
  "card": "colophon-module__2_2qdG__card",
  "cardLabel": "colophon-module__2_2qdG__cardLabel",
  "cardValue": "colophon-module__2_2qdG__cardValue",
  "grid": "colophon-module__2_2qdG__grid",
  "header": "colophon-module__2_2qdG__header",
  "inlineCode": "colophon-module__2_2qdG__inlineCode",
  "inlineLink": "colophon-module__2_2qdG__inlineLink",
  "intro": "colophon-module__2_2qdG__intro",
  "page": "colophon-module__2_2qdG__page",
  "section": "colophon-module__2_2qdG__section",
  "sectionTitle": "colophon-module__2_2qdG__sectionTitle",
  "stat": "colophon-module__2_2qdG__stat",
  "statGrid": "colophon-module__2_2qdG__statGrid",
  "statLabel": "colophon-module__2_2qdG__statLabel",
  "statNumber": "colophon-module__2_2qdG__statNumber",
  "tokenDesc": "colophon-module__2_2qdG__tokenDesc",
  "tokenItem": "colophon-module__2_2qdG__tokenItem",
  "tokenList": "colophon-module__2_2qdG__tokenList",
  "tokenName": "colophon-module__2_2qdG__tokenName",
});
